import React, { useState, useEffect, useRef, useMemo } from "react";
import PropTypes from 'prop-types';
import QRCodeStyling from "qr-code-styling";
import { useCardDetailContext } from '../../CardDetailContext';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import { useLocation } from "react-router-dom";
import axios from 'axios';
import UserDetailContext, { useUserDetailContext } from "../../UserDetailContext";

const apiKey = process.env.REACT_APP_API_KEY;
const objectId = localStorage.getItem("objectId");

const headers = {
    'x-api-key': apiKey,
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${objectId}`
};

const QrCodeCard = ({ CARDNAME_id, size }) => {
    const { cardQrStylesAll, cardDetailsAll } = useUserDetailContext(); // Use context for QR styles and card details


    const [CardQrStyles, setCardQrStyles] = useState(null);
    const [logoBase64, setLogoBase64] = useState(null);

    const [Logo, setLogo] = useState(null);
    const qrCodeRef = useRef(null);
    const qrCodeInstanceRef = useRef(null);

    const borderStyle = CardQrStyles?.border === 'border'
        ? { border: `2px solid ${CardQrStyles?.bordercolor || '#00000099'}`, borderRadius: '8px', display: 'inline-block' }
        : {};
    const borderSize = size + 4;
    // URL based on CARDNAME_id and objectId
    const [url, setUrl] = useState(`${process.env.REACT_APP_CARD_URL}/digital-identity/${CARDNAME_id}/${objectId}`);

    const [qrCodeOptions, setQrCodeOptions] = useState({
        dotsOptions: { color: "#121212", type: "square" },
        cornersSquareOptions: { color: "#000000", type: "square" },
        cornersDotOptions: { color: "#000000", type: "dot" },
        backgroundOptions: { color: "#ede8e8" },
    });

    // console.log("CardQrStyles CardQrStyles", CardQrStyles, "qrCodeOptions", qrCodeOptions);
    const devicePixelRatio = window.devicePixelRatio || 1;
    const actualSize = size * devicePixelRatio;

    useEffect(() => {
        const matchedStyle = cardQrStylesAll.find(style => style.CardName === CARDNAME_id);
        if (matchedStyle) {
            setCardQrStyles(matchedStyle);
        } else {
            // Default styles if no match is found
            setCardQrStyles({
                User_ID: objectId,
                CardType: CARDNAME_id,
                eyeBall: '',
                eyeBallcolor: '',
                eyeFrame: '',
                eyeFrameColor: '',
                qrPattern: '',
                qrPatterncolor: '#121212',
                border: '',
                bordercolor: '',
                addbg: '',
                addbgcolor: '#ede8e8',
            });
        }
    }, [CARDNAME_id, cardQrStylesAll]);

    // Update QR code options based on styles
    useEffect(() => {
        if (CardQrStyles) {
            setQrCodeOptions({
                dotsOptions: {
                    color: CardQrStyles.qrPatterncolor ?? "#121212",
                    type: CardQrStyles.qrPattern ?? "square"
                },
                cornersSquareOptions: {
                    color: CardQrStyles.eyeBallcolor ?? "#000000",
                    type: CardQrStyles.eyeBall ?? "dot"
                },
                cornersDotOptions: {
                    color: CardQrStyles.eyeFrameColor ?? "#000000",
                    type: CardQrStyles.eyeFrame ?? "dot"
                },
                backgroundOptions: {
                    color: CardQrStyles.addbgcolor ?? "#ede8e8"
                },
            });
        }
    }, [CardQrStyles]);



    const isValidLogoUrl = (url) =>
        url && /\.(png|jpe?g|gif|ico|webp)$/.test(url) && !url.includes('11signals.com'); // if 11signals is causing CORS

    // OR just do a HEAD request to verify it's accessible

    const createBase64Image = (url) => {
        return new Promise((resolve, reject) => {
            if (!url) {
                console.warn("No logo URL provided");
                resolve(undefined); // Skip logo
                return;
            }

            const image = new Image();
            image.crossOrigin = "Anonymous";

            image.onload = () => {
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');
                canvas.width = image.width;
                canvas.height = image.height;
                context.drawImage(image, 0, 0);
                resolve(canvas.toDataURL());
            };

            image.onerror = (e) => {
                console.error("Failed to load image for QR logo:", url, e);
                resolve(undefined); // Continue without the logo
            };

            image.src = url;
        });
    };

    // Set logo based on CARDNAME_id
    useEffect(() => {
        const matchedCard = cardDetailsAll.find(card => card.CardName === CARDNAME_id);
        if (matchedCard?.logo && matchedCard.logo !== '') {
            const proxiedLogoUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/qr-image-proxy?url=${encodeURIComponent(matchedCard.logo)}&qr=true`;
            setLogo(proxiedLogoUrl);
        }
    }, [CARDNAME_id, cardDetailsAll]);

    // Handle QR code rendering
    // useEffect(() => {
    //     const updateQrCode = async () => {
    //         if (qrCodeRef.current) {
    //             if (!qrCodeInstanceRef.current) {
    //                 const qrCode = new QRCodeStyling({
    //                     width: size,
    //                     height: size,
    //                     data: url,
    //                     ...qrCodeOptions,
    //                     image: Logo || undefined,
    //                     imageOptions: {
    //                         crossOrigin: "anonymous", // To avoid CORS issues
    //                         margin: 1, // Add margin around the logo
    //                     },
    //                 });
    //                 qrCode.append(qrCodeRef.current);
    //                 qrCodeInstanceRef.current = qrCode;
    //             } else {
    //                 qrCodeInstanceRef.current.update({
    //                     data: url,
    //                     ...qrCodeOptions,
    //                     image: Logo || undefined,
    //                 });
    //             }
    //         }
    //     };

    //     updateQrCode();
    // }, [Logo, url, qrCodeOptions]);

    // useEffect(() => {
    //     const updateQrCode = async () => {
    //         if (qrCodeRef.current) {
    //             // Convert logo to base64 if it exists
    //             // const base64Logo = Logo ? await createBase64Image(Logo) : undefined;

    //             if (!qrCodeInstanceRef.current) {
    //                 console.log("dataUrl ----->", url);
    //                 const qrCode = new QRCodeStyling({
    //                     width: 150,
    //                     height: 150,
    //                     data: url,
    //                     ...qrCodeOptions,
    //                     image: Logo,
    //                     imageOptions: {
    //                         crossOrigin: "anonymous",
    //                         hideBackgroundDots: true,
    //                         imageSize: 0.3
    //                     },
    //                 });
    //                 qrCode.append(qrCodeRef.current);
    //                 qrCodeInstanceRef.current = qrCode;
    //             } else {
    //                 console.log("dataUrl ELSE----->", url);
    //                 qrCodeInstanceRef.current.update({
    //                     data: url,
    //                     image: Logo,
    //                 });
    //             }
    //         }
    //     };

    //     updateQrCode();
    // }, [Logo, url, qrCodeOptions]);
    // console.log("Logo URL:", Logo);

    // useEffect(() => {
    //     if (!Logo) return;

    //     fetch(Logo)
    //         .then(res => res.blob())
    //         .then(blob => {
    //             const reader = new FileReader();
    //             reader.onloadend = () => {
    //                 setLogoBase64(reader.result); // this is base64 string
    //             };
    //             reader.readAsDataURL(blob);
    //         })
    //         .catch(err => {
    //             console.error("Error loading logo image:", err);
    //             setLogoBase64(null);
    //         });
    // }, [Logo]);

    // useEffect(() => {
    //     const updateQrCode = async () => {
    //         if (!qrCodeRef.current) return;

    //         // Clear previous QR if exists
    //         qrCodeRef.current.innerHTML = '';
    //         qrCodeInstanceRef.current = null;
    //         const qrCode = new QRCodeStyling({
    //             width: size,
    //             height: size,
    //             data: url,
    //             ...qrCodeOptions,
    //             // image: Logo || "",
    //             image: isValidLogoUrl(Logo) ? Logo : undefined,
    //             imageOptions: {
    //                 hideBackgroundDots: true,
    //                 // crossOrigin: 'anonymous'
    //                 ...(Logo?.includes('your-own-server.com') && { crossOrigin: 'anonymous' })
    //             }
    //         });

    //         qrCode.append(qrCodeRef.current);
    //         qrCodeInstanceRef.current = qrCode;
    //     };

    //     updateQrCode();
    // }, [Logo, url, qrCodeOptions]);


    useEffect(() => {
        if (!qrCodeRef.current) return;

        qrCodeRef.current.innerHTML = "";
        qrCodeInstanceRef.current = null;

        const qrCode = new QRCodeStyling({
            width: size,
            height: size,
            data: url,
            ...qrCodeOptions,
            image: Logo ? Logo : undefined, // use proxy image here
            imageOptions: {
                hideBackgroundDots: true,
                crossOrigin: "anonymous",
            },
        });

        qrCode.append(qrCodeRef.current);
        qrCodeInstanceRef.current = qrCode;
    }, [url, size, qrCodeOptions, Logo]);


    // const convertImageUrlToBase64 = async (imageUrl) => {
    //     const response = await fetch(imageUrl, { mode: 'cors' });
    //     const blob = await response.blob();

    //     return new Promise((resolve, reject) => {
    //         const reader = new FileReader();
    //         reader.onloadend = () => resolve(reader.result);
    //         reader.onerror = reject;
    //         reader.readAsDataURL(blob);
    //     });
    // };



    //  Check if starts with "data:image"

    // useEffect(() => {
    //     const updateQrCode = async () => {
    //         if (!qrCodeRef.current || !Logo) return;

    //         qrCodeRef.current.innerHTML = '';
    //         qrCodeInstanceRef.current = null;

    //         try {
    //             const base64Logo = await convertImageUrlToBase64(Logo);

    //             const qrCode = new QRCodeStyling({
    //                 width: size,
    //                 height: size,
    //                 data: url,
    //                 image: base64Logo, // <-- Use base64 here
    //                 imageOptions: {
    //                     hideBackgroundDots: true,
    //                     imageSize: 0.4,
    //                 },
    //                 ...qrCodeOptions,
    //             });

    //             qrCode.append(qrCodeRef.current);
    //             qrCodeInstanceRef.current = qrCode;
    //         } catch (err) {
    //             console.error('Failed to convert logo to base64:', err);
    //         }
    //     };

    //     updateQrCode();
    // }, [Logo, url, qrCodeOptions]);

    return (
        <div style={{ ...borderStyle, width: borderSize + 'px', height: borderSize + 'px' }}>
            <div id="qr-code-ref" style={{ width: size + 'px', height: size + 'px' }} ref={qrCodeRef}></div>
        </div>
    );
};


export default QrCodeCard

QrCodeCard.defaultProps = {
    size: 180
}



export const QrCodeVisitingCard = ({ cardDetails, size, CardQrStyles }) => {
    const qrCodeRef = useRef(null);
    const qrCodeInstanceRef = useRef(null);

    const defaultCardDetails = {
        cardName: 'Unknown',
        encryptedId: '',
        token: '',
        logo: ''
    };
    const [Logo, setLogo] = useState(null);
    const currentCardDetails = cardDetails || defaultCardDetails;
    const [CardQrStyless, setCardQrStyles] = useState({});
    
    const qrCodeUrl = useMemo(() => {
        if (!currentCardDetails?.cardName || !currentCardDetails?.token) return '';
        return `${process.env.REACT_APP_CARD_URL}/digital-identity/${currentCardDetails?.cardName}/${currentCardDetails?.token}`;
    }, [currentCardDetails?.cardName, currentCardDetails?.token]);

    const [qrCodeOptions, setQrCodeOptions] = useState({
        dotsOptions: {
            color: "#121212",
            type: "square"
        },
        cornersSquareOptions: {
            color: "#000000",
            type: "square"
        },
        cornersDotOptions: {
            color: "#000000",
            type: "dot"
        },
        backgroundOptions: {
            color: "#ede8e8"
        },
    });

    const defaultOptions = {
        dotsOptions: { color: "#121212", type: "square" },
        cornersSquareOptions: { color: "#000000", type: "square" },
        cornersDotOptions: { color: "#000000", type: "dot" },
        backgroundOptions: { color: "#ede8e8" }
    };

    useEffect(() => {
        if (CardQrStyles) {
            console.log("Updated CardQrStyles:", CardQrStyles);
            setCardQrStyles(CardQrStyles);
        }
    }, [CardQrStyles]);

    useEffect(() => {
        const logo = cardDetails?.logo;
        if (logo && logo !== '') {
            const proxied = `${process.env.REACT_APP_BACKEND_URL}/api/v1/qr-image-proxy?url=${encodeURIComponent(logo)}&qr=true`;
            setLogo(proxied);
        } else {
            setLogo(undefined); // show plain QR
        }
    }, [cardDetails?.logo]); // react to changes in logo string

    useEffect(() => {
        if (!CardQrStyless) return;

        setQrCodeOptions({
            dotsOptions: {
                color: CardQrStyless.qr_pattern_color || defaultOptions.dotsOptions.color,
                type: CardQrStyless.qr_pattern || defaultOptions.dotsOptions.type
            },
            cornersSquareOptions: {
                color: CardQrStyless.eyeball_color || defaultOptions.cornersSquareOptions.color,
                type: CardQrStyless.eyeball_shape || defaultOptions.cornersSquareOptions.type
            },
            cornersDotOptions: {
                color: CardQrStyless.eyeframe_color || defaultOptions.cornersDotOptions.color,
                type: CardQrStyless.eyeframe_shape || defaultOptions.cornersDotOptions.type
            },
            backgroundOptions: {
                color: CardQrStyless.bg_color || defaultOptions.backgroundOptions.color
            }
        });
    }, [CardQrStyless]);

    // console.log("qrCodeOptions qrCodeOptions------", qrCodeOptions);
    useEffect(() => {
        const updateQrCode = async () => {
            if (!qrCodeRef.current) return;

            // Clear previous QR if exists
            qrCodeRef.current.innerHTML = '';
            qrCodeInstanceRef.current = null;

            const qrCode = new QRCodeStyling({
                width: size,
                height: size,
                data: qrCodeUrl,
                ...qrCodeOptions,
                image: Logo ? Logo : undefined,
                imageOptions: {
                    hideBackgroundDots: true,
                    crossOrigin: 'anonymous'
                }
            });

            qrCode.append(qrCodeRef.current);
            qrCodeInstanceRef.current = qrCode;
        };

        updateQrCode();
    }, [qrCodeUrl, qrCodeOptions, Logo]);

    return (
        <>
            <div id="qr-code-ref" style={{ height: size + 'px' }} ref={qrCodeRef}></div>
        </>
    )
}

QrCodeVisitingCard.defaultProps = {
    size: 150
}